import { render } from "./Face.vue?vue&type=template&id=2927917f&scoped=true"
import script from "./Face.vue?vue&type=script&lang=js"
export * from "./Face.vue?vue&type=script&lang=js"

import "./Face.vue?vue&type=style&index=0&id=2927917f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2927917f"]])

export default __exports__